<div class="p-6">
  <form [formGroup]="searchForm">
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.meteringPointID' | translate}}</label>
            <input type="text" appInput formControlName="identification" [placeholder]="'meteringPoint.search.meteringPointID' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.streetName' | translate }}</label>
            <input type="text" appInput formControlName="streetName" [placeholder]="'address.streetName' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.houseNumber' | translate }}</label>
            <input type="text" appInput formControlName="buildingNumber" [placeholder]="'address.houseNumber' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.floor' | translate }}</label>
            <input type="text" appInput formControlName="floorIdentification" [placeholder]="'address.floor' | translate" />
          </app-input-group>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.zipCode' | translate }}</label>
            <input type="text" appInput formControlName="postalCode" [placeholder]="'address.zipCode' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.meteringPointType' | translate }}</label>
            <select appSelect formControlName="meteringPointType" [collection]="meteringPointTypeOptions">
            </select>
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.physicalStatus' | translate }}</label>
            <select appSelect formControlName="physicalStatus" [collection]="physicalStatusOptions">
            </select>
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.meterNumber' | translate }}</label>
            <input type="text" appInput formControlName="meterNumber" placeholder="Målernummer" />
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-2 align-middle">
        <button appButton (click)="table.search()">
          {{ 'common.search' | translate }}
        </button>
      </div>
    </app-card>
  </form>

  <app-table
    #table
    [config]="meteringPointTable"
    [(selectedElements)]="selectedElements"
  ></app-table>
</div>
